class MainMenuService {
    constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
      this.$q = $q;
      this.$http = $http;
      this.ngAuthSettings = ngAuthSettings;
      this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
    }
    

  }
  
  MainMenuService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
  
  export default MainMenuService;
  


/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/main-menu/main-menu.service.js
 **/